import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterSearchingCargasSolicitudesPcfExViewModel, CargasSolicitudesPcfExItemResultsViewModel } from './cargassolicitudespcfex.types';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ResetFiltersService } from 'src/app/components/core/_infrastructure/classes/services/reset-filters.service';
import { TcAnno, TcNumeroSemana } from '../../../core/_infrastructure/types/common';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class CargasSolicitudesPcfExService extends ResetFiltersService {
    public currentFilterCargasSolicitudesPcfEx?: FilterSearchingCargasSolicitudesPcfExViewModel;

    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }

    /**
     * Creates an HttpParms object through the values in the parameter.
     * @param payload FilterSearchingTCampaniaEspecificaViewModel
     * @returns HttpParams
     */
    private convertModelToHttpParms(payload: FilterSearchingCargasSolicitudesPcfExViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingCargasSolicitudesPcfExViewModel;

        for (k in payload) {
            let v;

            v = payload[k] || '';

            params = params.append(k, v);
        }

        return params;
    }

    getList(payload: FilterSearchingCargasSolicitudesPcfExViewModel): Observable<CargasSolicitudesPcfExItemResultsViewModel> {
        this.currentFilterCargasSolicitudesPcfEx = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getCargasSolicitudesPcfExPagedByFilter(params);
    }

    getAnnosCargas(): Observable<TcAnno[]> {
        return this.http.get<TcAnno[]>(this.baseUrl + 'api/mantenimiento/cargassolicitudespcfex/getAnnosCargas').pipe();
    }

    getNumeroSemana(idAnno: number): Observable<TcNumeroSemana[]> {
        return this.http.get<TcNumeroSemana[]>(this.baseUrl + 'api/mantenimiento/cargassolicitudespcfex/getNumeroSemana/' + idAnno).pipe();
    }

    getCargasSolicitudesPcfExPagedByFilter(params: HttpParams): Observable<CargasSolicitudesPcfExItemResultsViewModel> {
        return this.http
            .get<CargasSolicitudesPcfExItemResultsViewModel>(this.baseUrl + 'api/mantenimiento/cargassolicitudespcfex/pagedbyfilter/', { params: params })

            .pipe
            //catchError((error) => {
            //    console.log(error);
            //    return new Observable <CargasSolicitudesPcfExItemResultsViewModel>();
            //})
            ();
    }

    export(model: FilterSearchingCargasSolicitudesPcfExViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/cargassolicitudespcfex/postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    getLastSearch(): FilterSearchingCargasSolicitudesPcfExViewModel | undefined {
        return this.currentFilterCargasSolicitudesPcfEx;
    }

    resetFilter() {
        this.currentFilterCargasSolicitudesPcfEx = undefined;
    }
}
